<template>
    <div>
       <basic-container>

           <el-form :model="selectForm" ref="searchFormRef" label-suffix=':' label-width="100px"  v-show="searchBoxFlag" >
         <el-row :gutter="24">
             <el-col :span="6">
                          <el-form-item label="项目名称" prop="projectId"  >
                              <el-select v-model="selectForm.projectId" style="width:100%" placeholder="请选择" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
             <el-col :span="6">
                <el-form-item label="设备编号" prop="checkPass">
                        <el-input clearable v-model="selectForm.code" placeholder="设备名称" maxlength="20"></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="6">
                <el-form-item label="设备名称" prop="checkPass">
                    <el-input clearable v-model="selectForm.deviceName" placeholder="设备名称" maxlength="20"></el-input>
                </el-form-item>
            </el-col>
             <el-col :span='6' >
                  <el-form-item label="设备类型" prop="typeId">
                        <avue-input-tree  :props='treeDeviceTypeProps' style="width:100%;height:32px" :disabled="!deviceTypeFlag" v-model="selectForm.typeId" placeholder="设备类型" type="tree" :dic="deviceTypeList"></avue-input-tree>
                  </el-form-item>
             </el-col>

            <el-col :span="6">
               <el-form-item label="所属部门" prop="deptId" >
                    <avue-input-tree :disabled="!deptNameFlag" style="width:100%" :props='treeDeptProps' v-model="selectForm.deptId" placeholder="所属部门" type="tree" :dic="deptList"></avue-input-tree>
                </el-form-item>
            </el-col>
            <el-col :span="6">
               <el-form-item label="存放位置" prop="areaId" >
                              <avue-input-tree :disabled="!areaFlag" style="width:100%" :props='treeAreaProps' v-model="selectForm.areaId" placeholder="存放位置" type="tree" :dic="areaList"></avue-input-tree>
               </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="维保日期">
                     <el-date-picker
                                  style="width: 100%"
                                  clearable
                                  v-model="selectForm.timeRange"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  >
                              </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="合同名称" prop="contractName">
                        <el-input clearable v-model="selectForm.contractName" placeholder="合同名称" maxlength="50"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="维保单位" prop="signDept">
                        <el-input clearable v-model="selectForm.partnerName" placeholder="维保单位" maxlength="50"></el-input>
                </el-form-item>
            </el-col>
             <el-col :span="6">
                <el-form-item label="维保人" prop="realUpkeepManName">
                        <el-input clearable v-model="selectForm.realUpkeepManName" placeholder="维保人" maxlength="20"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <div style="float:right">
                              <el-button type="primary" icon="el-icon-search"  size="small" @click="searchRecord"> 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                </div>
            </el-col>


        </el-row>
        </el-form>
            <avue-crud
            v-if="showCrudFlag"
            :option="option"
            :table-loading="loading"
            :data="deviceMaintenanceRecordList"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @size-change="sizeChange"
            @refresh-change="onLoad">
             <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                  reduceHeight='30'
                :refOption="$refs.crud"
                ></searchFromShow>
            </template>
             <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord"> 新 增</el-button>
             <exportData :moduleType="400" @exportExcel="exportExcel"></exportData>
            <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="delConstractInvoice">删除</el-button> -->
            </template>
             <!-- <template slot-scope="scope" slot="projectId">
               {{getProjectName(scope.row.projectId)}}
             </template> -->
              <template slot-scope="scope" slot="serviceHour">

               <div class="time"><span>{{getHourTime(scope.row.serviceHour)}}</span></div>
             </template>
             <template slot-scope="scope" slot="amount">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.amount)  }}</span></div>
            </template>
            <template slot-scope="scope" slot="menu">
            <el-button
                type="text"
                size="small"
                icon="el-icon-tickets"
                @click="checkRecord(scope.row.id)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="editRecord(scope.row.id)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="removeRecord(scope.row.id)"
                >删除
            </el-button>
            </template>
        </avue-crud>
        <!-- 新增设备维保记录对话框 -->
        <!-- <el-dialog
          :title="dialogTitle"
          v-if="addOrEditOrWatchFlag"
          :visible.sync="addOrEditOrWatchFlag"
          append-to-body="true"
          width="80%"
          :close-on-click-modal="false"
          :before-close="handleClose">
          <recordOperate :projectList='projectList' :form='form' :isEdit='isEdit' @cancelOperate="cancelOperate" @submitOver='submitOver'></recordOperate>
        </el-dialog> -->
        <hr-dialog
        :title="dialogTitle"
          v-if="addOrEditOrWatchFlag"
          :visible="addOrEditOrWatchFlag"
          width="80%"
          :handleClose='handleClose'>
          <template

           v-slot:body>
             <recordOperate :projectList='projectList' :form='form' :isEdit='isEdit' @cancelOperate="cancelOperate" @submitOver='submitOver'></recordOperate>
          </template>
       </hr-dialog>
       </basic-container>

    </div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { deviceKeepRecordList ,getDetail,deleteKeepDetail} from '@/api/crmedical/device/deviceKeepRecord';
import { getDeviceMaintennanceRecordList,addDeviceMaintennanceRecord,getDeviceMaintennanceRecordDetail,removeDeviceMaintennanceRecord } from '@/api/crmedical/device/deviceMaintenanceRecord';
import { tree } from '@/api/crmedical/device/devicetype';
import { lazyAreaTree } from '@/api/crmedical/order/order-list/order-list';
import { lazyTree } from '@/api/crmedical/project/area';
import {
  treeByProjectDeptId,
  treeByProjectDeviceTypeId,
  treeByProjectAreaId,
} from '@/api/crmedical/device/device';
import recordOperate from '@/components/device/deviceKeepRecord/maintenanceRecoderAdd.vue'
import searchFromShow from '@/components/search-form-show/index'
 import {getToken} from '@/util/auth';
 import exportData from "@/components/exportData/exportDataSimple";
export default {
  components:{recordOperate,searchFromShow,exportData},
    data() {
    return {
      searchBoxFlag:true,
        searchHeight:'',
      deviceTypeFlag:false,
      deviceTypeList:[],
      areaFlag:false,//区域下拉框控制
      areaList:[],//区域数据集
      deptNameFlag:false,//部门下拉框控制
      deptList:[],//部门下拉框数据集
      showCrudFlag:false,
      recordEdit:false,
      addOrEditOrWatchFlag:false,
      dialogTitle:'新增设备维保记录',
      selectForm: {
        projectId: '',
        typeName:'',
        typeId:'',
        startTime:'',
        endTime :'',
        startAmount:'',
        endAmount:'',
        timeRange:[],
        code: '',
        deviceName:'',
        areaId:'',
        deptId:'',
        name:'',
        partnerName:'',
        contractName:'',
        realUpkeepManName:'',
      },
      showDetpTree:false,
      projectList:[],
      deviceMaintenanceRecordList:[],//设备维修记录list
      option:{
        index: true,
        selection: true,
        // reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'left',
        menuAlign: 'center',
        addBtn:false,
        editBtn: false,
        delBtn: false,
        border:true,
        height:'auto',

        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },

          {
            label: '设备类型',
            prop: 'deviceType',
          },
          {
            label: '设备编号',
            prop: 'code',
          },
          {
            label: '设备名称',
            prop: 'deviceName',
          },

          {
            label: '所属部门',
            prop: 'deptName',
          },
          {
            label: '存放位置',
            prop: 'areaName',
          },
          {
            label: '维保人',
            prop: 'realUpkeepManName',
          },
          {
            label: '维保时间',
            prop: 'realUpkeepTime',

          },

          {
            label: '维保金额',
            prop: 'amount',
            slot:true
          },
          {
            label: '维保单位',
            prop: 'partnerName',
          },
          {
            label: '合同编号',
            prop: 'contractCode',
          },
          {
            label: '合同名称',
            prop: 'contractName',
          },
          {
            label:'工单编号',
            prop:'orderCode',
            width:'160',
          },
          // {
          //   label: '维保工时',
          //   prop: 'serviceDuration',
          //   slot:true
          // },
          {
            label: '备注',
            prop: 'description',
            hide:true
          },

        ]
      },
       page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading:false,

      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
     treeDeviceTypeProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      treeAreaProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      form:{
         projectId: '',
         attachList:[]
      },
      objectTypeFlag:false,//设备类型下拉框使用状态
       treeFormAreaData: [], //所属区域
      treeFormDeptData: [], //所属部门
      treeFormData: [], //设备类型
      deviceList: [],
      recordIds:[],
      exportForm:{}
    };
  },
  created(){
      this.initData()
  },
  mounted(){
    this.calcHeight()
  },
  methods:{
       selectionChange(val){
      this.recordIds = []
      val.forEach(element => {
        this.recordIds.push(element.id)
      });
    },
     exportExcel(data) {

        let saveIds = data.exportExcelSelectionRadio=='1'?'':this.recordIds;
      
      if(saveIds.length==0 && data.exportExcelSelectionRadio == 2){
              this.$message({
                      message:'请选择需要导出的数据！',
                      type: 'warning'
              });
              return;
      }
        this.$confirm("是否导出设备维保数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出数据
            let projectId =this.exportForm.projectId ?this.exportForm.projectId:this.selectForm.projectId;
            let params = this.tool.formateObjToParamStr(this.exportForm)
            if(data.exportExcelSelectionRadio == 2){
              this.tool.downloadFile(`/api/upkeeptasklist/upkeepExport?${
                  this.website.tokenHeader
                }=${getToken()}&projectId=${projectId}&ids=${saveIds}`)
              
            }else{
              // 将条件参数拼接为路由传参格式
             
              // 
              this.tool.downloadFile(
                `/api/upkeeptasklist/upkeepExport?${
                  this.website.tokenHeader
                }=${getToken()}&ids=&`+ params,"abc.xlsx",'xlsx/xls'
                )
             
            }

          });
      },
     calcHeight(){
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight
      this.option.height = this.bodyHeight - this.searchHeight-279-30;
    },
    getDeviceTypeList(value) {
      this.deviceTypeFlag = false;
      treeByProjectDeviceTypeId({ projectId: value }).then((res) => {
        this.deviceTypeList = res.data;
        console.log('设备类型', this.deviceTypeList);
        this.deviceTypeFlag = true;
      });
    },
    treeByProjectDeptId(value) {//获取部门下拉框数据
      this.deptNameFlag = false;
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.deptList = res.data;
        this.deptNameFlag = true;
      });
    },
    getAreaList(value) {//获取区域
      this.areaFlag = false;
      treeByProjectAreaId({ projectId: value }).then((res) => {
        this.areaList = res.data;
        this.areaFlag = true;
      });
    },
    getHourTime(time){
      let hour = parseInt(time/60);
      let minute = parseInt(time%60)
      let str = ''
      if(hour>0){
        str = hour + "小时" +minute + "分钟"
        return  str
      }else{
        str = minute + "分钟"
        return str
      }
    },
    getProjectName(id){
      let str
      try{
        this.projectList.forEach(item =>{
        if(item.id == id){
         str= item.name
          throw new Error()
        }
      })
      }catch(e){
        return str
      }
    },
        handleClose(){
            this.form={
            projectId: '',
            attachList:[]
          }
           this.addOrEditOrWatchFlag = false
        },
        //新增编辑取消
        cancelOperate(){
          this.addOrEditOrWatchFlag = false
        },
        //新增，编辑结束
        submitOver(){
          this.addOrEditOrWatchFlag = false
          this.onLoad()
        },
        removeRecord(id){
          this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             deleteKeepDetail(id).then(()=>{
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onLoad()
            })
        })

        },
        editRecord(id){
          getDetail(id).then(({data})=>{
            this.isEdit = true
            this.form = data
            this.dialogTitle = "编辑"
            this.addOrEditOrWatchFlag = true

          })
        },
        checkRecord(id){
          getDetail(id).then(({data})=>{
            this.isEdit = false
            this.form = data
            this.$set(this.form,'serviceDuration',data.serviceDuration)
            this.dialogTitle = "查看"
            this.addOrEditOrWatchFlag = true
          })
        },
        //新增
        addRecord(){
          this.form = {
            projectId: '',
            attachList:[]
          }
          this.dialogTitle = "新增"
          this.isEdit = true
          this.addOrEditOrWatchFlag = true
          this.form.projectId = this.selectForm.projectId
        },
        //重置搜索条件
        searchClear(){
          this.selectForm.typeName = ""
          this.selectForm.typeId = ""
          this.selectForm.startTime = ""
          this.selectForm.endTime = ""
          this.selectForm.startAmount = ""
          this.selectForm.endAmount = ""
          this.selectForm.timeRange = []
          this.selectForm.code = ""
          this.selectForm.deviceName = ""
          this.selectForm.deptId = ''
          this.selectForm.areaId = ''
          this.selectForm.name = ''
          this.selectForm.contractName = ''
          this.selectForm.partnerName = ''
          this.selectForm.realUpkeepManName =''
          // this.selectForm.projectId = this.projectList[0].id
        },
        //搜索
        searchRecord(){
           this.page.currentPage = 1
          let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
          if ((this.selectForm.startAmount==''&&this.selectForm.endAmount=='')||(reg.test(this.selectForm.startAmount)&&reg.test(this.selectForm.endAmount))) {
            if(this.selectForm.startAmount>this.selectForm.endAmount){
              //大金额在后面
              let transfromNum = this.selectForm.endAmount
              this.selectForm.endAmount = this.selectForm.startAmount
              this.selectForm.startAmount = transfromNum
            }
            console.log(this.selectForm.timeRange)
            if(this.selectForm.timeRange&&this.selectForm.timeRange.length>0){
                this.selectForm.startTime = this.dayjs(this.selectForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.selectForm.endTime = this.dayjs(this.selectForm.timeRange[1]).format('YYYY-MM-DD 23:59:59')
            }else{
                this.selectForm.timeRange = []
                this.selectForm.startTime = ''
                  this.selectForm.endTime = ''
            }
             this.onLoad()
          } else {
            let sum = Number(this.selectForm.startAmount)  + Number(this.selectForm.endAmount)
            if(sum == this.selectForm.startAmount||sum == this.selectForm.endAmount){
              this.$message.error('请输入一个金额范围');
            }else{
              this.$message.error('金额格式不正确，请输入小数点前9位，后2位');
            }
          }

        },
        initData(){
          getProjectList().then((res) => {
            this.projectList = res.data;
            if (this.projectList.length > 0) {
                this.$set(this.selectForm, 'projectId', this.projectList[0].id);
                        if (this.projectList.length > 0) {
                    this.$set(this.selectForm, 'projectId', this.projectList[0].id);
                    this.getAreaList(this.selectForm.projectId);
                    this.treeByProjectDeptId(this.selectForm.projectId);
                    this.getDeviceTypeList(this.selectForm.projectId);
                    this.onLoad();
                    }

                this.showCrudFlag = true;
            }
          });
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;
        },
        onLoad(page) {
            page = page || this.page;
            this.loading = true;
            if(this.selectForm.projectId){
               this.exportForm = Object.assign({},this.selectForm)
               deviceKeepRecordList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, this.selectForm)).then(({data})=>{
                this.deviceMaintenanceRecordList = data.records
                this.page.total = data.total
                this.loading = false;
            })
            }
           
      },
      getObjectTypeName(dictKey) {
      let ObjectTypeName;
      this.objectType.forEach((element) => {
        if (element.dictKey == dictKey) {
          ObjectTypeName = element.dictValue;
        }
      });
      return ObjectTypeName;
    },

    queryAreaSelect(value) {
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
            if (item.nodeType === 1) {
              item.disabled = true;
            }
          });
        }
        this.areaIdFlag = true
        this.treeFormAreaData = data;
      });
    },
    queryDeviceSelect(value) {
      tree({ id: 0, projectId: value, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.objectTypeFlag = true
        this.treeFormData = data;
      });
    },
    typeNodeTreeClick(node) {
      console.log(node);
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.selectForm.typeName = nodeTitle;
      this.selectForm.typeId = nodeId;
    },
    areaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      if(this.selectForm.projectId){
        lazyAreaTree({ parentId: id, projectId: this.selectForm.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
      }
    },
    areaNodeTreeClick(node) {
      // if (parseInt(node.nodeType) == 1) {
      //   // this.$message.error();
      //   return;
      // }
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.selectForm.areaName = nodeTitle;
      this.selectForm.areaId = nodeId;
    },

    handleDeptNodeClick(node) {
      //  if (parseInt(node.nodeType) == 1) {
      //     // this.$message.error();
      //     return;
      //   }
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.deptName = nodeTitle;
      this.selectForm.deptId = nodeId;
      console.log(node);
    },
    typeLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      tree({ id: id, projectId: this.projectId, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        } else {
          data = [];
        }
        resolve(data);
      });
    },
      //项目id切换
      objectTypeClear(){
        this.selectForm.typeName = '';
        this.selectForm.typeId = '';
      },
      areaClear(){
      this.selectForm.areaName=""
      this.selectForm.areaId=""
    },
    deptClear(){
      this.selectForm.deptName=""
      this.selectForm.deptId=""
    },
     projectIdChange(){
      this.areaIdFlag=false
      this.deptIdFlag=false
      this.objectTypeFlag=false

      this.selectForm.deptId=""
      this.selectForm.areaId=""
      this.selectForm.deptName=""
      this.selectForm.areaName=""
      this.selectForm.typeId=""
      this.selectForm.typeName=""
      this.getAreaList(this.selectForm.projectId);
      this.treeByProjectDeptId(this.selectForm.projectId);
      this.getDeviceTypeList(this.selectForm.projectId);
    },
  }
}
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
.time{
  text-align: center
}
::v-deep .el-col-8{
  height: 54px;
}
::v-deep .avue-crud__right {
  display: flex;
}
</style>
